import { ENV } from '@/constants';
import { useRouter } from 'next/router';
import React from 'react';

interface CampaignPreviewFooterProps {
  shortId: string;
}

export default function CampaignPreviewFooter({ shortId }: CampaignPreviewFooterProps) {
  const router = useRouter();
  const { portalCampaignShortId } = router.query as { portalCampaignShortId?: string };
  const utmTags = {
    utm_source: 'discover-campaign',
    utm_medium: 'discover-public',
    utm_content: 'panel',
    utm_campaign: shortId,
  };

  return (
    <footer className="fixed lg:static left-0 right-0 bottom-0 bg-white border-t lg:border border-outline-neutral-light shadow-light-up text-center p-4 sm:p-6 z-[90] flex flex-col items-center gap-4 lg:rounded-lg">
      <h2 className="text-[16px] leading-6 sm:text-headline-h2 m-0 sm:leading-headline-h2 font-headline-h2 text-content-primary">
        To see the full details and submit your response please register now
      </h2>

      <div className="flex flex-col w-full items-center gap-2 text-body-lg leading-highlights-lg text-content-secondary">
        <p className="text-highlights-lg">Already an Inpart member?</p>
        <a
          href={`${ENV.NEXT_PUBLIC_COMPANIES_APP_URL}/register/academic?${new URLSearchParams({
            ...(portalCampaignShortId && { portalCampaignShortId }),
          })}`}
          className="bg-action-fill-primary-enabled hover:bg-action-fill-primary-hover w-50 h-10 flex items-center justify-center rounded-lg no-underline shadow-medium-down text-button-lg leading-button-lg text-content-inverted "
        >
          Start Submission
        </a>
      </div>

      <p className="text-content-secondary text-body-lg flex items-center gap-1 flex-col leading-5">
        Not yet an Inpart member?
        <a
          href={`${ENV.NEXT_PUBLIC_COMPANIES_APP_URL}/register/academic?${new URLSearchParams({
            ...utmTags,
            ...(portalCampaignShortId && { portalCampaignShortId }),
          }).toString()}`}
          className="text-action-content-link-enabled text-button-lg leading-5 p-1"
        >
          Create a free account
        </a>
        <span className="mx-1 hidden lg:block text-body-lg leading-5">or</span>
        <a href="/about" className="text-action-content-link-enabled text-button-lg leading-button-lg p-1">
          Find out more about Inpart
        </a>
      </p>
    </footer>
  );
}
